import React, {useEffect, useState} from 'react'
import {Button, Input, message, Form} from 'antd'
import {useNavigate} from 'react-router-dom'
import Cookies from 'js-cookie';
import {observer} from 'mobx-react';
import store from '../store';

import request from '../util/request'

let timer = null;
let atoken = 4444
const Login = () => {
  let navigate = useNavigate();

  const [form] = Form.useForm();
  const [countdown, setCountdown] = useState(0);
  const [loading, setLoading] = useState(false);

  const token = Cookies.get('snail_token');

  useEffect(() => {
    clearInterval(timer);
    return () => {
      clearInterval(timer)
    }
  }, []);

  useEffect(() => {
    if (!!token) {
      navigate('/');
    }
  }, [token]);

  useEffect(() => {
    if (countdown === 59) {
      timer = setInterval(() => {
        setCountdown((pre) => pre - 1)
      }, 1000)
    } else if (countdown === 0) {
      clearInterval(timer)
    }
  }, [countdown]);

  const handleLogin = () => {
    form.validateFields().then(value => {
      setLoading(true);
      request({
        method: 'post',
        url: '/snailapi/auth/login',
        params: {
          telephone: value.phone,
          verification_code: value.verificationCode
        }
      }).then(response => {
        setLoading(false);
        if (response && response.mobile && response.nickname && response.token) {
          Cookies.set('CLS_SNAIL_CUSTOMER_CMS_USERID', response.mobile);
          Cookies.set('CLS_SNAIL_CUSTOMER_CMS_NICKNAME', response.nickname);
          Cookies.set('CLS_SNAIL_CUSTOMER_CMS_PATH', response.path);
          // token使用后端指定的请求内名称
          Cookies.set('snail_token', response.token);
          Cookies.set('SNAIL_IS_TAG', response.is_tag);
          const menu = JSON.stringify(response.permission);
          Cookies.set('CLS_SNAIL_CUSTOMER_CMS_MENU', menu);

          store.setToken(response.nickname);
          store.setMenu(menu);

          // 默认跳转首页
          navigate('/')
        }
      }).catch(e => {
        setLoading(false);
        message.error(e.message || '请求出错')
      })
    })
  }

  const getVerification = () => {
    form.validateFields(['phone']).then(value => {
      request({
        method: 'get',
        url: '/snailapi/auth/captcha',
        params: {
          mobile: value.phone
        }
      }).then((response) => {
        setCountdown(59);
        if (!!response.message) {
          message.success(response.message)
        }
      }).catch(e => {
        message.error(e.message || '验证码发送失败')
      })
    })
  }
  return (
    <div>
      <div className="d-f f-b-c bg-c-fff login-header">
        <img className="login-header-logo" src="/logo-text.png" />
      </div>
      <div className="d-f f-s-c o-h login">
        <div className="f-g-1 h-100p login-background">
          <img className="w-100p h-100p o-f-c" src="/login-background.png" />
        </div>
        <div className="f-s-0 h-100p bg-c-fff login-content-box">
          <div className="t-a-c b-c-efad71-ef5545 login-snail-logo-box">
            <img className="d-b m-a login-snail-logo" src="/snail-logo.png" />
          </div>
          <Form
            form={form}
            labelCol={{span: 0}}
            wrapperCol={{span: 24}}
            preserve={false}
            autoComplete="off"
          >
            <Form.Item >
              <div className="f-s-24 f-w-b l-h-1375 c-272727">手机号登陆</div>
            </Form.Item>
            <Form.Item
              name="phone"
              validateTrigger="onBlur"
              rules={[
                {
                  required: true,
                  message: '手机号不能为空'
                },
                {
                  pattern: /^\d{11}$/,
                  message: '请输入正确的手机号'
                }
              ]}
            >
              <Input className="f-s-16 l-h-1375 c-272727 b-c-f8f8f8 login-input" placeholder="请输入您的手机号码"/>
            </Form.Item>
            <Form.Item
              required
            >
              <div className="d-f f-s-c w-100p">
                <Form.Item
                  name="verificationCode"
                  className="f-g-1 m-r-10"
                  rules={[{
                    required: true,
                    message: '验证码不能为空'
                  }]}
                >
                  <Input className="f-s-16 l-h-1375 c-272727 b-c-f8f8f8 login-input" placeholder="请输入验证码" />
                </Form.Item>
                <Form.Item>
                  {
                    (countdown >= 60 || countdown <= 0) ?
                    <div className="f-s-0 d-f f-c-c f-s-12 l-h-1375 c-p t-a-c c-fff bg-c-de0422 login-verification-box" onClick={getVerification}>获取验证码</div> :
                    <div className="f-s-0 d-f f-c-c f-s-12 l-h-1375 t-a-c c-fff bg-c-de0422 login-verification-box">{countdown}s</div>
                  }
                </Form.Item>
              </div>
            </Form.Item>
            <Form.Item wrapperCol={{ span: 24 }}>
              <Button
                type="primary"
                className="w-100p f-s-18 l-h-138889 c-fff bg-c-2a2c3b login-button"
                onClick={handleLogin}
                loading={loading}
              >
                登录
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  )
}

export default observer(Login);